import ApiService from './ApiService'

const InternalUsersService = {
    getUserRoles(user_id) {
        return ApiService.post('internal_user.get_user_roles', null, { user_id })
    },

    toggleUserRole(user_id, data) {
        return ApiService.post('internal_user.toggle_user_role', data, { user_id })
    },

    sendInternalInvite(data) {
        return ApiService.post('internal_invite.store', data)
    },

    resendInternalInvite(invite) {
        return ApiService.get('internal_invite.resend', { internal_invite: invite })
    },

    deleteInternalInvite(invite) {
        return ApiService.delete('internal_invite.destroy', { internal_invite: invite })
    },
}

export default InternalUsersService